import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Skeleton from '@mui/material/Skeleton';
import CardActions from '@mui/material/CardActions';
import Grid from '@mui/material/Grid';
import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';

export const SkeletonCard: React.ComponentType<any> = ({}) => {
  return (
    <Card
      sx={{
        width: '100%',
        position: 'relative',
        overflow: 'visible',
      }}
    >
      <CardHeader
        sx={{
          '@media (max-width:600px)': {
            p: '8px'
          },
        }}
        title={
          <Skeleton
            animation="wave"
            height={20}
            width="80%"
            style={{ marginBottom: 8 }}
          />
        }
        subheader={<Skeleton animation="wave" height={15} width="40%" />}
      />

      <CardContent
        sx={{
          '@media (max-width:600px)': {
            padding: '0px 8px',
          },
        }}
      >
        <Skeleton sx={{ height: 200 }} animation="wave" variant="rectangular" />
      </CardContent>

      <CardActions
        sx={{
          justifyContent: 'end',
          alignItems: 'flex-start',
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={4} md={4} lg={12}>
            <Skeleton animation="wave" height={40} />
          </Grid>
          <Grid item xs={4} md={4} lg={12}>
            <Skeleton animation="wave" height={40} />
          </Grid>
          <Grid item xs={4} md={4} lg={12}>
            <Skeleton animation="wave" height={40} />
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};
